import localStorageLang from "../local/localStorageLang";

export default {
    actions: {
        changeLang(ctx, lang) {
            ctx.commit('updateLang', lang)
        },
    },
    mutations: {
        updateLang(state, lang) {
            state.lang = lang
            window.i18nHelper.set(lang)
            localStorageLang.set(lang)
        },
    },
    state: {
        lang: localStorageLang.get()
    },
    getters: {
        // should be used only when site loads
        getCurrentLang(state) {
            return state.lang
        },
    },
}
